import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { DatePicker } from 'components/DatePicker/DatePicker'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import type { Dispatch, SetStateAction } from 'react'
import { colors } from 'settings/colors'

export const GoodReadingsButton = ({
  lastGoodReading,
  setLastGoodReading,
}: {
  lastGoodReading?: routes.SoilCalibrationSettingsGet.Response['lastGoodReading']
  setLastGoodReading: Dispatch<SetStateAction<routes.SoilCalibrationSettingsGet.Response['lastGoodReading']>>
}) => {
  return (
    <div
      css={{
        backgroundColor: colors.subtleBackground,
        borderRadius: 4,
        padding: 12,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <p>{translate.phrases.banyanApp('First full day of good readings')}</p>
      <DatePicker
        clearable
        clearButtonProps={{
          onClick: () => {
            setLastGoodReading('')
          },
        }}
        placeholder={translate.phrases.banyanApp('All dates included')}
        onChange={(newDate) => {
          if (!newDate) return

          setLastGoodReading(moment.tz(newDate, moment.tz.guess()).toISOString())
        }}
        maxDate={new Date()}
        value={lastGoodReading && !isNaN(Date.parse(lastGoodReading)) ? new Date(lastGoodReading) : null}
      />
    </div>
  )
}
